import styled from "styled-components";
import { ResourceListRow } from "../../ResourceListRow";
export const InvisibleRow = styled(ResourceListRow) `
  border: none;
  overflow: hidden;
  height: 0;
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW52aXNpYmxlUm93LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUmVzb3VyY2VMaXN0L2NvbXBvbmVudHMvRGV0ZWN0b3JSb3cvc3R5bGVkL0ludmlzaWJsZVJvdy50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBRXhELE1BQU0sQ0FBQyxNQUFNLFlBQVksR0FBRyxNQUFNLENBQUMsZUFBZSxDQUFDLENBQUE7Ozs7Q0FJbEQsQ0FBQyJ9